import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";

/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-05-31 17:37:08
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-01-12 11:56:07
 * @FilePath     : /marketing-landing-fe/src/utils/wechat.ts
 * @Description  : 未添加文件描述
 */
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { MINI_PROGRAM_CONFIG_KEY, MINIP_INFO, WX_APP_ID } from '@/const';
import { getApolloKey, getWxConfig, getWxSchemaUrl } from '@/services/landing';
import { isWXBrowser, reportError } from '.';
import { polarisAppIds } from './constants';
export var isPolaris = function isPolaris() {
  var ua = navigator.userAgent;
  return polarisAppIds.findIndex(function (appid) {
    return ua.indexOf(appid) >= 0;
  }) >= 0 || window.location.href.includes('miniName=northstar');
};
export function weChatConf(ops) {
  try {
    if (!isWXBrowser()) {
      return;
    }

    var appId = ops.appId || WX_APP_ID || 'wxd730409a8aa8f7bb';
    getWxConfig({
      appId: appId,
      url: ops.linkUrl
    }).then(function (res) {
      if (res.resultCode === 200 && (window === null || window === void 0 ? void 0 : window.wx)) {
        var baseConf = __assign(__assign({
          debug: false
        }, res.data), {
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'showMenuItems', 'hideMenuItems']
        });

        if (ops.openApp) {
          baseConf.openTagList = ['wx-open-launch-app'];
        }

        wx.config(baseConf); // 微信分享

        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: ops.title,
            desc: ops.desc,
            link: ops.linkUrl,
            imgUrl: ops.imgUrl,
            success: function success() {}
          });
          wx.updateTimelineShareData({
            title: ops.title,
            desc: ops.desc,
            link: ops.linkUrl,
            imgUrl: ops.imgUrl,
            success: function success() {}
          });
        });
      }
    });
  } catch (e) {
    reportError(e);
  }
}
export function openToWechatBySchema(miniStr, miniInfo) {
  return __awaiter(this, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , getWxSchemaUrl({
            miniProgram: miniInfo.miniProgram,
            query: miniStr
          })];

        case 1:
          data = _a.sent().data;
          window.location.href = data === null || data === void 0 ? void 0 : data.schemaUrl;
          return [2
          /*return*/
          , data === null || data === void 0 ? void 0 : data.schemaUrl];
      }
    });
  });
}
export function openToWechatByApp(miniStr, miniInfo) {
  return __awaiter(this, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , getWxSchemaUrl({
            miniProgram: miniInfo.miniProgram,
            query: miniStr
          })];

        case 1:
          data = _a.sent().data;
          window.location.href = data === null || data === void 0 ? void 0 : data.schemaUrl;
          return [2
          /*return*/
          , data === null || data === void 0 ? void 0 : data.schemaUrl];
      }
    });
  });
}
export function openToMiniByScheme(_a) {
  var linkUrl = _a.linkUrl,
      miniConf = _a.miniConf,
      needLogin = _a.needLogin;
  return __awaiter(this, void 0, void 0, function () {
    var miniStr, miniInfo, _b, resultCode, data;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          miniStr = "type=webview&needLogin=".concat(needLogin || 0, "&linkUrl=").concat(encodeURIComponent(linkUrl));
          miniInfo = MINIP_INFO;
          return [4
          /*yield*/
          , getApolloKey(miniConf || MINI_PROGRAM_CONFIG_KEY)];

        case 1:
          _b = _c.sent(), resultCode = _b.resultCode, data = _b.data;

          if (resultCode === 200 && data) {
            miniInfo = JSON.parse(data);
          }

          return [2
          /*return*/
          , openToWechatBySchema(miniStr, miniInfo)];
      }
    });
  });
}